import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HotelSegmentDetailComponent } from '@shared/hotel-segment-detail/hotel-segment-detail.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@NgModule({
  declarations: [
    HotelSegmentDetailComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    IconDsComponent,
  ],
  exports: [
    HotelSegmentDetailComponent
  ],
  providers: [
    DatePipe
  ]
})
export class HotelSegmentDetail { }
